/**
 * 工具方法
 * */


/**
 * 获取URL参数信息
 * @param {*} name 参数名称
 */
export const getUrlParamsTools = name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
};

/**
 * 手机与H5交互
 * @param interactive 交互类型状态码
 * @param state 标识 IOS or Android
 * @param title 标题
 */
export const phoneInteractiveTools =  (interactive,state,title) => {
    if(state === 'IOS'){
        if(window.webkit){
            window.webkit.messageHandlers.phoneInteractive.postMessage({
                interactive:interactive,
                title:title,
            });
        }
    }else{
        if(window.WebViewJavascriptBridge){
            window.WebViewJavascriptBridge.callHandler(
                'interactive',
                {
                    'param': interactive,
                    'title':title,
                }
            );
        }
    }

};


export const isWeixinOrAlipayTools = () => {
    const ua = window.navigator.userAgent;
    //判断是不是微信
    if (ua.indexOf("MicroMessenger") > 0 ) {
        return "WeiXIN";
    }
    //判断是不是支付宝
    if (ua.indexOf("Alipayclient") > 0) {
        return "Alipay";
    }
    //哪个都不是
    return "false";
};

/**
 * 获取当前日期
 * @returns {string}
 */
export const getNowFormatDate = () => {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
};


/**
 * 更具对象的某个值找到其坐在数组的索引
 * @param arr 数组
 * @param key 对象属性名
 * @param val 对象属性值
 * @returns {boolean|*}
 */
export const removeArrByKeyTools = (arr,key,val) => {
    let i = arr.length;
    while (i--) {
        if (arr[i][key] === val) {
            return i;
        }
    }
    return false;
};

/**
 * 键盘遮挡
 */
export const changeBlurTools = () => {
    setTimeout(() => {
        const scrollH = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scroll(0,Math.max(scrollH - 1,0));
    },200);
};

export const changeFocusTools = () => {
    setTimeout(() => {
        document.activeElement.scrollIntoView();
    })
};